import request from '@/utils/request';

function transformItem2Dto(item) {
  const dto = {
    ...item
  };
  dto['orderLineStatusID'] = item.id;
  delete dto.id;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto['orderLineStatusID']
  };
  delete item['orderLineStatusID'];
  return item;
}

export function getSummary(domainID, someMonday, productGroupID, workshopID) {
  const params = {
    domainID: domainID,
    someMonday: someMonday
  };
  if (productGroupID) {
    params.productGroupID = productGroupID;
  }
  if (workshopID) {
    params.workshopID = workshopID;
  }
  return request({
    method: 'get',
    url: 'order-line-status/summary',
    params: params
  });
}

export const storeExtensions = {
  actions: {
    getSummary({ dispatch }, { domainID, someMonday, productGroupID, workshopID }) {
      return new Promise((resolve, reject) =>
        getSummary(domainID, someMonday, productGroupID, workshopID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  },
  getters: {},
  mutation: {},
  state: {}
};

export const apiOverrides = { transformItem2Dto, transformDto2Item };
